<template>
    <div class="maintain-chart">
        <el-row>
            <el-col :span="16">
                <div id="deliveryMaintainPieChart" style="height: 100%;width: 100%"></div>
            </el-col>

            <el-col :span="8" class="maintain-info clearfix">
                <div class="maintain-info-item" v-for="(item, key) in deliveryFaultPie.series[0].data" :key="key">
                    <p> {{item.name}}</p>
                    <p class="maintain-number">{{item.value}}</p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import deliveryMaintainPie from './deliveryMaintainPie.js'
    export default {
        name: '',
        components: {},
        mounted: function () {
            this.init()
        },
        data: function () {
            return {
                myChart: null,
                deliveryFaultPie: deliveryMaintainPie,
            }
        },
        methods: {
            init(){
                this.myChart = echarts.init(document.getElementById('deliveryMaintainPieChart'));
                this.myChart.setOption(this.deliveryFaultPie)
            }
        },
    }
</script>

<style lang="scss">
    .maintain-chart {
        height: 100%;
        .el-row {
            height: 100%;
            .el-col {
                height: 100%;
            }
        }
        .maintain-info {
            font-size: $small_font_size;
            padding-top: $padding;
            .circle {
                display: inline-block;
                width: $small_font_size;
                height: $small_font_size;
                border-radius: $small_font_size;
                background-color: $f_sec_color;
            }

            .maintain-info-item {
                width: 50%;
                float: left;
                margin-bottom: $padding;
                padding-left: $padding;
                // text-align: center;
                * {
                    color: $f_sec_color;
                }
                .maintain-number {
                    color: $f_th_color;
                    font-size: $font_size;
                    margin: $padding-2 $padding;
                    margin-bottom: $padding-5;

                }
            }
        }
    }
</style>
